<template>
    <div>
      <loading 
            :active.sync="isLoading" 
            :opacity="0.8"
            color="#f5365c"
            :is-full-page="true">
        </loading>
      <base-header key="1" type="gradient-blue" class="pb-6 pb-8 pt-5 pt-md-8">
        <!-- Card stats -->
        <div class="row">
            <div class="col-xl-4 col-lg-4 col-md-4">
                <stats-card title="Número de clientes"
                    type="gradient-red"
                    :sub-title="clientsCount"
                    icon="ni ni-satisfied"
                    class="mb-4 mb-xl-0">
                </stats-card>
            </div>
            <div class="col-xl-8 col-lg-8 col-md-8">
                <stats-card title="Último cliente agregado"
                    type="gradient-red"
                    :sub-title="lastClientAdded.razonSocial"
                    :location="lastClientAdded.ciudad ? (lastClientAdded.ciudad + ', ' + lastClientAdded.estado) : '' "
                    icon="ni ni-square-pin"
                    class="mb-4 mb-xl-0">
                      <template slot="footer">
                        <div>
                            <span class="text-nowrap">Agregado el:</span>
                            <span class="text-nowrap"> {{getReadableDate(lastClientAdded.createdOn)}}</span>
                        </div>
                      </template>
                </stats-card>
            </div>
            
        </div>
      </base-header>

      <div key="2" class="container-fluid mt--7">
        <div class="row">
            <div class="col">
                <estaciones-table title="Estaciones de servicio" :tableData="tableData" @get-details="toggleDetailsView"></estaciones-table>
            </div>
        </div>
      </div>
    </div>
</template>
<script>
  import EstacionesTable from './Tables/EstacionesTable';
  import moment from "moment";
  import router from '../router'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';


  export default {
    name: 'tables',
    components: {
      EstacionesTable,
      Loading
    },
    methods: {
        getReadableDate(timestamp){
            moment.locale('es');
            let time = moment(timestamp, 'x')
            return time.format('LL');
        },
        toggleDetailsView(data){
          router.replace({ path: `profile/${data.clientId}/${data.estacionId}`});
        }
    },
    created(){
      const token = localStorage.getItem('id_token');
      this.isLoading = true;
      fetch(`${process.env.VUE_APP_VREMEC_API}/api/stations`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then(response => response.json())
        .then((data) => {
          this.tableData = data.Data.Items;
          let mostRecent = Math.max.apply(Math, this.tableData.map((client) => client.createdOn));
          this.lastClientAdded = this.tableData.find((client) => client.createdOn === mostRecent);
          this.clientsCount = data.Data.Count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          this.isLoading = false;
        })
    },
    data() {
      return {
        isLoading: false,
        tableData: [],
        detailsView: false,
        clientsCount: '-',
        lastClientAdded: {
            razonSocial: '',
            createdOn: '',
            createdBy: '',
            ciudad: '',
            estado: ''
        }
      }
    }

  };
</script>
<style></style>
